import React from 'react'

function Card({ cardImg, cardName, isSelected, setSelectedProvider, isDisabled }) {
    return (
        <div className={`cursor-pointer flex items-center gap-[15px] border-1 p-1 rounded-md ${isSelected ? "border-[#7059ef] border-2" : " border-2"} ${isDisabled ? "opacity-30" : ""}`} onClick={() => { !isDisabled && setSelectedProvider(cardName) }}>
            <img className='h-[45px] w-[102.857142857px]  ' style={{ objectFit: 'contain' }} src={cardImg} />
        </div>
    )
}

export default Card